export const predefinedColorsList = [
  '#000000',
  '#333333',
  '#4D4D4D',
  '#666666',
  '#808080',
  '#999999',
  '#B3B3B3',
  '#CCCCCC',
  '#FFFFFF',
  '#FF0000',
  '#FF3F00',
  '#FF7F00',
  '#FFBF00',
  '#FEFD00',
  '#BFFD04',
  '#80FD00',
  '#3EFD02',
  '#01FD00',
  '#02FE3F',
  '#02FE7F',
  '#01FFBF',
  '#01FFFF',
  '#00BFFF',
  '#007FFF',
  '#003FFF',
  '#1625FF',
  '#3F25FF',
  '#7F25FF',
  '#BF25FF',
  '#FF24FF',
  '#FF18BF',
  '#FF0B7F',
  '#FF013F',
  '#058A06',
  '#8A4A09',
  '#61210A',
];
